<div class="grid-container full-height full v-pad">
  @if (!(workOrderLoading$ | async)) {
    <div class="form-width">
      <div class="grid-x">
        <div class="cell large-12">
          <span class="bold">Scan and upload documents for application:</span> {{applicationNumber}}
        </div>
        <div class="cell large-12">
          <span class="bold">Organization:</span> {{companyName}}
        </div>
        <div class="cell large-12">
          <span class="bold">Application Type:</span> {{applicationType}}
        </div>
      </div>
      <div [formGroup]="uploadForm">
        @for (upload of workOrder.uploads; track upload) {
          <div class="user-form-max-width text-align-center margin-top">
            <div class="question-row">
              <div class="question-cell text-align-left" [ngStyle]="{'flex-grow': upload.flexGrow || 1 }">
                <ng-template dynamic-component-loader [componentName]="upload.type" [componentData]="upload" [componentContext]="workOrder.flowInstance.context" [formGroup]="filesForm" (fileUploaded)="saveFile($event)" (fileDeleted)="deleteFile($event)"></ng-template>
              </div>
            </div>
            @if (isPaperSubmissionUpload(upload)) {
              <div class="question-row">
                <div class="question-cell text-align-left" [ngStyle]="{'flex-grow': 1 }">
                  <label [for]="'type' + upload.id">
                    Select the type of document being uploaded<span [ngClass]="{ 'red': getUploadInvalid(upload.key), 'bold': getUploadInvalid(upload.key) }">*</span>:
                  </label>
                </div>
                <div class="question-cell" [ngStyle]="{'flex-grow': 1 }">
                  <select [id]="'type' + upload.id" (change)="documentTypeSelected(upload)" [formControlName]="upload.key">
                    @for (type of documentTypes; track type) {
                      <option [value]="type.id">{{type.name}}</option>
                    }
                  </select>
                </div>
                @if (hasUntypedFiles(upload)) {
                  <div class="question-cell" [ngStyle]="{'flex-grow': 1}">
                    <span class="bold red">Please select a document type for the uploaded file.</span>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
      <div class="grid-x">
        <span class="minor-margin-right"><button class="button" (click)="exit()">Exit</button></span><button class="button" style="display: none;" (click)="complete()">Scans Complete</button><!-- Task #29144 to hide complete button -->
      </div>
    </div>
  } @else {
    Loading data...
  }
</div>
<a style="display: none;" href="" target="_blank" #downloadLink rel="noopener noreferrer"></a>
